import type { IPriceDataInfo, PriceData } from "./types";

export function indexPriceData(
  entries: IPriceDataInfo[],
  keyField: keyof IPriceDataInfo = "name",
): PriceData {
  return entries.reduce<PriceData>((acc, entry) => {
    const key = entry[keyField];
    if (typeof key === "string" && key.length > 0) {
      acc[key] = entry;
    }
    return acc;
  }, {});
}

export interface SerializePriceDataOptions {
  pretty?: boolean;
  sort?: boolean;
  asArray?: boolean;
}

export function serializePriceData(
  priceData: PriceData,
  options: SerializePriceDataOptions = {},
): string {
  const { pretty = true, sort = true, asArray = true } = options;
  const space = pretty ? 2 : undefined;

  if (asArray) {
    const entries = sort
      ? Object.values(priceData).sort((a, b) => a.name.localeCompare(b.name))
      : Object.values(priceData);
    return JSON.stringify(entries, null, space);
  }

  if (!sort) {
    return JSON.stringify(priceData, null, space);
  }

  const sortedKeys = Object.keys(priceData).sort((a, b) => a.localeCompare(b));
  const sorted: PriceData = {};
  for (const key of sortedKeys) {
    const entry = priceData[key];
    if (entry) {
      sorted[key] = entry;
    }
  }

  return JSON.stringify(sorted, null, space);
}
